import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { PayrollsService } from "@/services/payrolls";
import { UpdatePayrollSplit } from "@/types/payrollSplit";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { usePayrollParams } from "./usePayrollParams";

export const useUpdatePayrollSplitDetailMutation = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { payrollId, entryId } = usePayrollParams();
  const queryClient = useQueryClient();

  return useMutationWithErrorHandling({
    errorTitle: t("payrolls.errors.update"),
    mutationFn: (entry: UpdatePayrollSplit) =>
      PayrollsService.updateSplit(entryId, entry),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.Payrolls, payrollId, "split", entryId],
      });
      queryClient.invalidateQueries({
        queryKey: [Module.Payrolls, payrollId],
      });
      toast({
        title: t("payrolls.success.update"),
      });
    },
  });
};
